import {Injectable} from '@angular/core';
import {Effect, Actions} from '@ngrx/effects';
import * as profileAction from '../actions/profile.action';
import {map, switchMap, mergeMap} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {Action, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import * as fromStore from '../../../store';
import {ProfileService} from '../../profile.service';


@Injectable()
export class ProfileEffect {
  constructor(private actions: Actions, private profileService: ProfileService, private store: Store<fromStore.AppState>) {
  }

  @Effect()
  getPopup: Observable<Action> = this.actions.ofType(profileAction.GET_POPUP)
    .map((action: profileAction.GetPopup) => action.payload)
    .pipe(
      mergeMap(body => {
        return this.profileService.getPopup(body)
          .map(res => new profileAction.GetPopupSuccess(res))
          .catch(error => of(new profileAction.GetPopupError(error)));
      })
    );

  @Effect()
  updateProfileDetail: Observable<Action> = this.actions.ofType(profileAction.UPDATE_PROFILE_DETAILS)
    .map((action: profileAction.UpdateProfileDetails) => action.payload)
    .pipe(
      mergeMap(body => {
        return this.profileService.updateProfileDetails(body)
          .map(res => new profileAction.UpdateProfileDetailsSuccess(res))
          .catch(error => of(new profileAction.UpdateProfileDetailsError(error)));
      })
    );

}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/profile/store/effects/profile.effect.ts